import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
});

// Interceptor odpowiedzi
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 403 || !error.response) {
            localStorage.removeItem('tokenRestaurant');
            window.location.href = '/restaurantPanel';
            return new Promise(() => {});
        }
        return Promise.reject(error);
    }
);

export default api;
